import { I18n } from 'common/i18n';

import { FilterScope, getAllOption, getScope } from './translations';
import { Filters } from 'common/components/AssetBrowser/lib/helpers/enabled_filters';
import { SelectDropdownConfig } from './filter-config';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { FilterType, SelectOption } from './types';

const scope = getScope(FilterScope.Source);

export const getSourceOptions = (list: string[]): SelectOption[] => {
  const sourceOptions = [getAllOption(scope)];
  list?.forEach((source) => sourceOptions.push({ label: source, value: source }));

  return sourceOptions;
};

export const sourceConfigs: SelectDropdownConfig = {
  filterName: Filters.Source,
  label: I18n.t('label', { scope: getScope(FilterScope.Source) }),
  getOptions: (list: string[]) => getSourceOptions(list),
  dispatchAction: filters.changeSource,
  filterType: FilterType.SelectDropdown,
};
